import Image from 'next/image';

// Deux fichiers, un par thème ; l'affichage bascule en CSS (.logo-l / .logo-d) sans flash.
export default function Logo({ size = 38 }: { size?: number }) {
	return (
		<>
			<Image src="/logo-ks.svg" alt="" width={size} height={size} className="logo logo-l" aria-hidden="true" unoptimized />
			<Image src="/logo-ks-sombre.svg" alt="" width={size} height={size} className="logo logo-d" aria-hidden="true" unoptimized />
		</>
	);
}
